/* eslint-disable global-require */
export default {
    DownloadApp: require('./assets/images/downloadApp.png'),
};
